export enum GraduationType {    
    Unknown = 0,
    School = 10,
    VocationalTraining = 20,
    Diploma = 30,
    Bachelor = 40,
    Master = 50,
    Doctor = 60
}